import React from 'react';
import './Experience.scss';

const Experience = () => {
  return (
    <article className="about__experience experience">
      <h2 className="experience__title">Experience</h2>
      <div className="experience__content">
        <div className="experience__text-container">
          <h3>Industries & Business models</h3>
          <p>
            Experience across SaaS, cybersecurity, and B2B/B2B2C products focused <span>on complex systems
            and scalable workflows I have work experience with</span>{' '}
          </p>
        </div>
        <div className="experience__text-container">
          <h3>Platforms & Devices</h3>
          <p>
            I design multi-platform products with a strong focus on{' '}
            <span>complex web systems, dashboards,</span> multi-tenant workflows, and{' '}
            <span>products with AI-driven features</span>
          </p>
        </div>
        <div className="experience__text-container">
          <h3>AI & Workflow Innovation</h3>
          <p>
            Participated in transitioning product teams from traditional handoff-based delivery to{' '}
            <span>collaborative design-in-code workflows built around Claude Code, Cursor,</span>{' '}
            and shared repositories
          </p>
        </div>
      </div>
    </article>
  );
};

export default Experience;
